// extracted by css-extract-rspack-plugin
export default {"root":"root-XczZgW","table":"table-mOqNB0","row":"row-lbTEvh","cell":"cell-zpxQ5a"};